import React from 'react';

import Tooltip from '../tooltip';

import { ReactComponent as HelpIcon } from './icons/help_icon.svg';
import { ReactComponent as HybridTokenIcon } from './icons/hybrid_token_icon.svg';
import { ReactComponent as RubleIcon } from './icons/ruble_icon.svg';

import './token-balance.scss';

interface IProps {
  title: string;
  balance?: string;
  type: string;
}

const IconMap = {
  ruble: RubleIcon,
  hybrid: HybridTokenIcon,
} as Record<string, React.ElementType>;

const TokenBalance: React.FC<IProps> = ({ title, balance, type }) => {
  const Icon = IconMap[type];

  return (
    <div className="module-token">
      <p className="module-token__help">
        <Tooltip
          title={
            type === 'ruble'
              ? 'Право денежного требования'
              : 'Права денежного требования, поставки товаров и исполнения услуг'
          }
          placement="left-start"
        >
          <span>
            <HelpIcon className="icon icon--20" />
          </span>
        </Tooltip>
      </p>
      <div className="module-token__left">
        <div className="module-token__icon">
          <Icon className="icon" />
        </div>
        <h2 className="module-token__title">{title}</h2>
      </div>
      <div className="module-token__right">
        <div className="module-token__sum">
          {`${balance} `}
          <span>₽</span>
        </div>
      </div>
    </div>
  );
};

export default TokenBalance;
